// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export * from "./keyVaultAuthenticationPolicy.js";
export * from "./parseKeyVaultIdentifier.js";
export type * from "./extendedClientOptions.js";
export type { AdditionalPolicyConfig } from "@azure-rest/core-client";
